import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../../utils";
const TONE_CLASSES = {
    neutral: "bg-surface-subtle text-fg-secondary",
    green: "bg-bliks-green-surface text-bliks-green-800",
    blue: "bg-info-solid/10 text-info",
    violet: "bg-highlight-solid/10 text-highlight",
    amber: "bg-warning-solid/10 text-warning",
    danger: "bg-danger-solid/10 text-danger"
};
export function EntityIcon({ icon, tone = "neutral", size = 36, className }) {
    return /*#__PURE__*/ _jsx("div", {
        className: cn("inline-flex shrink-0 items-center justify-center rounded-lg", TONE_CLASSES[tone], className),
        style: {
            width: size,
            height: size
        },
        children: icon
    });
}

//# sourceMappingURL=EntityIcon.js.map